export { default as Booth } from "./pages/booth/index.jsx";
